import PropTypes from "prop-types";
import React from "react";
import { Button } from "@mui/material";
import ButtonCss from "./Buttons.module.css";

const Buttons = (props) => {
  return (
    <Button
      type="submit"
      variant="contained"
      sx={props.sx}
      onClick={props.onClick}
      className={ButtonCss.buttonDesign}
      endIcon={props.endIcon}
    >
      {props?.text}
    </Button>
  );
};

Buttons.propTypes = {
  endIcon: PropTypes.any,
  onClick: PropTypes.any,
  sx: PropTypes.any,
  text: PropTypes.any
}

export default Buttons;
